module.exports = __webpack_public_path__ + "img/居家-收據-01.3f910661.png";